<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <!-- FILTROS 
    <br />
  <div class="card">
    <div id="collapse1">
      <div class="card-body">
        <form v-on:submit.prevent="buscarLotes()">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for=""></label>
                <input class="form-control" id="id" v-model="filtro" placeholder="Localizar lotes..." />
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <button @click="buscarLotes()" style="border-radius: 2px" type="submit" class="btn btn-info">Buscar</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  -->
  <br />
  <div class="card card-solid">
    <div class="card-body">
      <div class="row" style="width: 100%">
        <section class="col-12 col-sm-12 col-md-3" style="text-align: center; justify-content: center">
          <span style="display: inline-block; height: 100%; vertical-align: middle"></span>
          <img
            :src="getImagePathLeilao(leilao)"
            alt="Product Image"
            style="width: 100%; vertical-align: middle"
            data-toggle="modal"
            data-target="#image-modal"
          />
          <!--
          <div style="margin-top: -27px !important" v-if="leilao && leilao.leilao_retirado == 1">
            <span class="right badge badge-danger" style="bottom: 0; text-transform: uppercase; font-size: 18px">Leilão retirado</span>
          </div>
          -->
          <!--
          <img
            :src="getImagePathLeilao(leilao)"
            alt="Product Image"
            style="width: 90%; position: absolute; top: 20%; left: 50%; transform: translate(-50%, -50%)"
            data-toggle="modal"
            data-target="#image-modal"
          />
          -->
        </section>
        <section class="col-12 col-sm-12 col-md-9" style="line-height: 20px !important">
          <span style="font-weight: bold; color: #4a4949; font-size: 25px; text-transform: uppercase">{{ leilao.cidade + "/" + leilao.estado }}</span>
          <br />
          <p style="color: #adadad; font-size: 18px">{{ leilao.comitente.nome }}</p>

          <b style="font-weight: bold; color: #696969; font-size: 18px">LEILÃO ID {{ leilao.id }} - {{ leilao.leilao_titulo }}</b>
          <br />
          <br />
          <b style="color: #545353; font-size: 18px">
            Modalidade:
            <a v-if="leilao.leilao_1_modalidade == 'venda'" style="text-transform: uppercase; font-weight: 500; color: #696969">VENDA DIRETA</a>
            <a v-else style="text-transform: uppercase; font-weight: 500; color: #696969">{{ leilao.leilao_1_modalidade }}</a>
          </b>
          <br />
          <b style="color: #545353; font-size: 18px">
            Local:
            <a style="font-weight: 500; color: #696969; text-transform: uppercase">{{ leilao.leilao_local }}</a>
          </b>
          <br />
          <div v-if="leilao.comitente">
            <br />
            <b v-if="leilao.comitente" style="color: #545353; font-size: 18px">
              Comitente:
              <a style="font-weight: 500; color: #696969; text-transform: uppercase">{{ leilao.comitente.nome }}</a>
              <a v-if="leilao.comitente.cidade" style="font-weight: 500; color: #696969; text-transform: uppercase">
                - {{ leilao.comitente.cidade.nome }}
              </a>
              <a v-if="leilao.comitente.estado" style="font-weight: 500; color: #696969; text-transform: uppercase">
                - {{ leilao.comitente.estado.sigla }}
              </a>
            </b>
          </div>

          <!-- DATAS E VALORES DOS LEILÕES -->
          <div v-if="leilao.leilao_num_pracas > 1 && !venda_direta" style="border-bottom: none; text-align: left; line-height: 23px">
            <div style="font-size: 18px; color: #545353" :class="leilao.leilao_1_realizado === 1 || leilao.leilao_retirado == 1 ? 'realizado' : ''">
              <b>1º Leilão:</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
            </div>

            <!-- DATA 2 -->
            <div
              style="font-size: 18px; color: #545353"
              v-if="leilao.leilao_num_pracas >= 2"
              :class="leilao.leilao_2_realizado === 1 || leilao.leilao_retirado == 1 ? 'realizado' : ''"
            >
              <b>2º Leilão:</b>
              {{ formatDate(leilao.leilao_2_data) + "h" }}
            </div>

            <div style="font-size: 18px; color: #545353" v-else><br /></div>

            <!-- DATA 3 -->
            <div
              style="font-size: 18px; color: #545353"
              v-if="leilao.leilao_num_pracas >= 3"
              :class="leilao.leilao_3_realizado === 1 || leilao.leilao_retirado == 1 ? 'realizado' : ''"
            >
              <b>3º Leilão:</b>
              {{ formatDate(leilao.leilao_3_data) + "h" }}
            </div>

            <!-- DATA 4 -->
            <div
              style="font-size: 18px; color: #545353"
              v-if="leilao.leilao_num_pracas >= 4"
              :class="leilao.leilao_4_realizado === 1 || leilao.leilao_retirado == 1 ? 'realizado' : ''"
            >
              <b>4º Leilão:</b>
              {{ formatDate(leilao.leilao_4_data) + "h" }}
            </div>
          </div>

          <!-- ÚNICO LEILÃO-->
          <div
            v-else-if="leilao.leilao_num_pracas == 1 && !venda_direta"
            style="border-bottom: none; text-align: left; line-height: 20px; margin-top: 8px"
          >
            <div
              style="font-size: 18px; color: #545353; margin-bottom: 3px"
              :class="leilao.leilao_1_realizado === 1 || leilao.leilao_retirado == 1 ? 'realizado' : ''"
            >
              <b>Único leilão:</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
            </div>
          </div>

          <!-- VENDA DIRETA-->
          <div v-else-if="venda_direta" style="border-bottom: none; text-align: left; line-height: 20px; margin-top: 8px; text-transform: none">
            <div style="font-size: 18px; color: #545353" :class="leilao.leilao_1_realizado === 1 || leilao.leilao_retirado == 1 ? 'realizado' : ''">
              <b style="">Disponível até:</b>
              {{ formatDate(leilao.leilao_1_data) + "h" }}
            </div>
          </div>

          <br />
          <button @click="voltar()" class="btn btn-primary" style="font-size: 18px; font-weight: bold; padding: 5px 18px 5px 18px; margin-right: 5px">
            Voltar
          </button>
          <button
            @click="exibir_modal_contato = true"
            class="btn btn-secondary btn-flat"
            style="border-radius: 7px; font-weight: bold"
            data-toggle="modal"
            data-target="#contato-modal"
          >
            <i class="fa fa-envelope"></i>
            CONTATO
          </button>
          <button
            v-if="show_habilitacao && !venda_direta"
            @click="checkHabilitacao"
            class="btn btn-success btn-flat"
            style="border-radius: 7px; font-weight: bold; margin-left: 7px"
            :style="btn_habilitacao_style"
          >
            <i class="fa fa-check"></i>
            PEDIR HABILITAÇÃO
          </button>

          <!-- AGUARDANDO LIBERAÇÃO -->
          <button
            v-if="show_aguardando_habilitacao"
            @click="aguardandoLiberacao"
            class="btn btn-warning btn-flat"
            style="border-radius: 7px; font-weight: bold; margin-left: 7px"
          >
            AGUARDANDO LIBERAÇÃO
          </button>

          <!-- PENDÊNCIA AGUARDANDO -->
          <div
            class="card"
            style="margin-top: 5px; background-color: rgb(219, 181, 10) !important"
            v-if="habilitacao && habilitacao.motivo_pendencia && show_aguardando_habilitacao"
          >
            <div class="card-body p-2">
              <i class="fa-solid fa-circle-exclamation"></i>
              <b style="margin-left: 3px">Motivo pendência:</b>
              <br />
              <br />
              <p style="margin-top: -5px; font-size: 18px">{{ habilitacao.motivo_pendencia }}</p>
            </div>
          </div>

          <!-- HABILITAÇÃO BLOQUEADA -->
          <button
            v-if="show_habilitacao_bloqueada"
            class="btn btn-danger-red btn-flat"
            style="border-radius: 7px; font-weight: bold; margin-left: 7px; color: white"
          >
            HABILITAÇÃO BLOQUEADA
          </button>

          <!-- PENDÊNCIA BLOQUEIO -->
          <div
            class="card"
            style="margin-top: 5px; background-color: #dc3545 !important; color: white"
            v-if="habilitacao && habilitacao.motivo_bloqueio && show_habilitacao_bloqueada"
          >
            <div class="card-body p-2">
              <i class="fa-solid fa-circle-exclamation"></i>
              <b style="margin-left: 3px">Motivo bloqueio:</b>
              <br />
              <br />
              <p style="margin-top: -5px">{{ habilitacao.motivo_bloqueio }}</p>
            </div>
          </div>

          <button
            v-if="show_auditorio_btn && !venda_direta"
            @click="checkIsHabilitado"
            class="btn btn-success btn-flat"
            style="border-radius: 7px; font-weight: bold; margin-left: 7px"
          >
            <i class="fa-solid fa-right-to-bracket"></i>
            IR PARA O AUDITÓRIO
          </button>
        </section>
      </div>
    </div>
  </div>

  <!-- MODAL PEDIR HABILITAÇÃO-->
  <div
    v-if="exibir_modal_habilitacao"
    class="modal fade"
    id="habilitacao-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="imageModal"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h4>Solicitar habilitação</h4>
          <br />
          <div class="row">
            <!-- NOME -->
            <div class="col-sm-12">
              <div class="form-group">
                <label>Uma habilitação é necessária para poder participar deste leilão. Por favor, solicite a sua habilitação.</label>
                <br />
                <br />
                <a href="/termos-leiloes-eletronicos">Clique aqui para visualizar os termos de uso.</a>

                <br />
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="formData.termos" />
                &nbsp;&nbsp; Eu li e concordo com os termos de uso para participação do leilão eletrônico.

                <br />
                <span style="color: red" v-for="error in v$.termos.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>

              <button type="submit" class="btn btn-primary" @click="validateFields()" style="margin-right: 15px">Solicitar habilitação</button>

              <button data-toggle="modal" id="cancelar" data-target="#habilitacao-modal" class="btn btn-danger">Voltar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card card-solid" v-if="leilao.leilao_info_geral">
    <div class="card-body">
      <div class="row" style="padding-left: 20px; width: 100%">
        <section class="col-12 col-sm-12 col-md-12">
          <i class="fa-solid fa-circle-exclamation" style="margin-right: 10px"></i>
          <a style="font-weight: bold; font-size: 18px">Informações importantes</a>
          <br />
          <div v-html="leilao.leilao_info_geral"></div>
        </section>
      </div>
    </div>
  </div>
  <br />
  <!-- FILTROS -->
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <form v-on:submit.prevent="buscarLotes()">
            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  class="form-control"
                  id="id"
                  v-model="filtro"
                  placeholder="Pesquisar lotes ATIVOS NESSE LEILÃO (Título, Descrição, Cidade, Estado, Número do Lote)"
                />

                <span class="input-group-append">
                  <button @click="buscarLotes()" style="border-radius: 2px" type="submit" class="btn btn-info">Buscar</button>
                  <button @click="limparFiltros()" style="border-radius: 2px" type="submit" class="btn btn-default">Limpar filtros</button>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div style="padding: 0px 0px 10px 0px; color: red" v-if="searchBuscado">
    Exibindo resultados para "{{ filtro }}"
    <i class="fa-regular fa fa-close" style="margin-left: 5px; color: red; cursor: pointer" @click="limparFiltros"></i>
  </div>

  <div class="card-footer clearfix" style="margin-bottom: 0px; padding: 0px 0px 0px 0px">
    <ul class="pagination pagination-sm m-0 p-0 float-right" style="top: 0px; right: 1px">
      <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

      <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
        <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
          {{ pagina }}
        </a>
      </li>

      <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
    </ul>
  </div>

  <!-- CARD LOTE-->
  <div v-for="lote in lotes" :key="lote" :value="lote">
    <a :href="getUrlLote(lote)">
      <div class="card p-2">
        <div class="row">
          <section
            style="
              text-align: center;
              background: linear-gradient(
                0deg,
                rgba(184, 179, 179, 1) 0%,
                rgba(252, 252, 252, 1) 48%,
                rgba(252, 252, 252, 1) 57%,
                rgba(184, 179, 179, 1) 100%
              );
            "
            class="col-lg-3"
          >
            <span style="display: inline-block; height: 100%; vertical-align: middle"></span>

            <img
              v-if="lote.thumb"
              class="im"
              style="vertical-align: middle; max-width: 100%; height: 100%; object-fit: cover"
              :style="(leilao.leilao_num_pracas == 1 && !venda_direta) || venda_direta ? 'aspect-ratio: 4/2;' : 'aspect-ratio: 4/2;'"
              :src="getImagePath(lote)"
            />
            <img v-else class="im" style="object-fit: scale-down !important; max-width: 80%; max-height: 80%" :src="getImagePath(lote)" />
            <!-- TAGS DE STATUS QUANDO JÁ TEM A TAG DESOCUPADO-->
            <div style="position: absolute; float: right; top: 0px; right: 6px" v-if="lote.lote_situacao == 'desocupado'">
              <span
                class="right badge badge-success"
                style="margin-right: 2px; text-transform: uppercase; font-size: 14px; background-color: red !important"
                v-if="lote.lote_status == 'retirado'"
              >
                Lote retirado
              </span>

              <span
                class="right badge badge-success"
                style="margin-right: 2px; text-transform: uppercase; font-size: 14px"
                v-if="lote.lote_status == 'vendido'"
              >
                Lote vendido
              </span>

              <span
                class="right badge badge-success"
                style="margin-right: 2px; text-transform: uppercase; font-size: 14px; background-color: #301904 !important"
                v-if="lote.lote_status == 'sem_licitante'"
              >
                Lote sem licitante
              </span>

              <span class="right badge badge-success" style="background-color: #301904 !important; text-transform: uppercase; font-size: 14px">
                Desocupado
              </span>
            </div>

            <div style="position: absolute; float: right; top: 0px; right: 5px" v-else>
              <span class="right badge badge-success" style="text-transform: uppercase; font-size: 14px" v-if="lote.lote_status == 'vendido'">
                Lote vendido
              </span>

              <span
                class="right badge badge-success"
                style="text-transform: uppercase; font-size: 14px; background-color: #301904 !important"
                v-if="lote.lote_status == 'sem_licitante'"
              >
                Lote sem licitante
              </span>

              <span
                class="right badge badge-success"
                style="text-transform: uppercase; font-size: 14px; background-color: red !important"
                v-if="lote.lote_status == 'retirado'"
              >
                Lote retirado
              </span>
            </div>

            <div v-if="!pracas_fechadas">
              <div
                style="position: absolute; float: left; bottom: 5px; left: 5px; text-align: left"
                v-if="lote.lote_lance > 0 && leilao.leilao_1_modalidade != 'venda'"
              >
                <span class="right badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                  Maior lance: R$ {{ toCurrency(lote.lote_lance) }}
                </span>
                <br />
                <span class="right badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                  {{ getApelidoFormatado(lote.user.apelido) }}
                </span>
              </div>
              <div style="position: absolute; float: left; bottom: 5px; left: 5px" v-else-if="leilao.leilao_1_modalidade != 'venda'">
                <span class="right badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                  Lance inicial: R$ {{ toCurrency(getValorAtual(lote)) }}
                </span>
              </div>
            </div>
          </section>
          <section class="col-lg-9" style="text-align: left" id="detalhes">
            <div style="padding-left: 25px; padding-top: -3px !important; margin-top: -6px !important">
              <b style="color: #4a4949; font-size: 20px">LOTE {{ lote.lote_numero + " - " + lote.lote_titulo }}</b>

              <!-- DESCRICAO LOTE -->
              <!--
              <div v-if="lote.lote_descricao && lote.lote_descricao.includes('</p>')" style="color: black" v-html="lote.lote_descricao"></div>
              <div v-else style="color: black">
                <p>{{ lote.lote_descricao }}</p>
              </div>
              -->

              <div style="margin-top: 0px; line-height: 20px">
                <b style="color: #545353; font-size: 18px">
                  Modalidade:
                  <a v-if="leilao.leilao_1_modalidade == 'venda'" style="text-transform: uppercase; font-weight: 500; color: #696969">VENDA DIRETA</a>
                  <a v-else style="text-transform: uppercase; font-weight: 500; color: #696969">{{ leilao.leilao_1_modalidade }}</a>
                </b>
                <br />
                <b style="color: #545353; font-size: 18px">
                  Local:
                  <a style="font-weight: 500; color: #696969; text-transform: uppercase">{{ leilao.leilao_local }}</a>
                </b>
                <br />
                <div v-if="lote.processo">
                  <b style="font-size: 18px; color: #545353">
                    Processo:
                    <a style="font-weight: 500; color: #696969">{{ lote.processo.processo_numero }}</a>
                  </b>
                  <br />
                </div>
                <div v-if="leilao.comitente">
                  <b style="color: #545353; font-size: 18px; line-height: 17px">
                    Comitente:
                    <a style="font-weight: 500; color: #696969; text-transform: uppercase">{{ getComitente(lote) }}</a>
                    <!-- 
                  <a style="font-weight: 500; color: #696969">{{ lote.processo.processo_vara }}</a>
                  <a v-if="lote.processo.cidade" style="font-weight: 500; color: #696969">- {{ lote.processo.cidade.nome }}</a>
                  <a v-if="lote.processo.estado" style="font-weight: 500; color: #696969">- {{ lote.processo.estado.sigla }}</a>
                  --></b>
                </div>
                <b style="font-size: 18px; color: #545353">
                  Avaliação:
                  <a style="font-weight: 500; color: #696969">R$ {{ toCurrency(lote.lote_avaliacao) }}</a>
                </b>
              </div>
              <!-- DATAS E VALORES DOS LEILÕES -->
              <div v-if="leilao.leilao_num_pracas > 1 && !venda_direta" style="border-bottom: none; text-align: left; line-height: 20px">
                <div style="font-size: 18px; color: #545353">
                  <b :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''">
                    1º Leilão:&nbsp;
                  </b>
                  <span :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''">
                    {{ formatDate(leilao.leilao_1_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_1) }}
                  </span>
                  <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 1">&nbsp;- VENDIDO</span>
                </div>

                <!-- DATA 2 -->
                <div style="font-size: 18px; color: #545353" v-if="leilao.leilao_num_pracas >= 2">
                  <b :class="leilao.leilao_2_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''">
                    2º Leilão:&nbsp;
                  </b>
                  <span :class="leilao.leilao_2_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''">
                    {{ formatDate(leilao.leilao_2_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_2) }}
                  </span>
                  <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 2">&nbsp;- VENDIDO</span>
                </div>

                <!-- DATA 3 -->
                <div style="font-size: 18px; color: #545353" v-if="leilao.leilao_num_pracas >= 3">
                  <b :class="leilao.leilao_3_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''">
                    3º Leilão:&nbsp;
                  </b>
                  <span :class="leilao.leilao_3_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''">
                    {{ formatDate(leilao.leilao_3_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_3) }}
                  </span>
                  <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 4">&nbsp;- VENDIDO</span>
                </div>

                <!-- DATA 4 -->
                <div style="font-size: 18px; color: #545353" v-if="leilao.leilao_num_pracas >= 4">
                  <b :class="leilao.leilao_4_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''">
                    4º Leilão:&nbsp;
                  </b>
                  <span :class="leilao.leilao_4_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''">
                    {{ formatDate(leilao.leilao_4_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_4) }}
                  </span>
                  <span v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 4">&nbsp;- VENDIDO</span>
                </div>
              </div>

              <!-- ÚNICO LEILÃO-->
              <div v-else-if="leilao.leilao_num_pracas == 1 && !venda_direta" style="border-bottom: none; text-align: left; line-height: 20px">
                <div
                  style="font-size: 18px; color: #545353"
                  :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                >
                  <b>Único leilão:&nbsp;</b>
                  {{ formatDate(leilao.leilao_1_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_1) }}
                </div>
              </div>

              <!-- VENDA DIRETA -->
              <div v-else-if="venda_direta" style="border-bottom: none; text-align: left; line-height: 20px">
                <div
                  style="font-size: 18px; color: #545353; margin-bottom: 3px"
                  :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                >
                  <b>Disponível até:&nbsp;</b>
                  {{ formatDate(leilao.leilao_1_data) + "h" }} -
                  <a>pelo valor de</a>
                  R$ {{ toCurrency(lote.lote_valor_1) }}
                </div>
              </div>
            </div>
            <!--
            <div style="background-color: #fafafa; position: absolute; bottom: 0; left: 0; width: 99%; padding: 5px 5px 5px 5px">
              <b style="color: #4a4949; padding-left: 30px; font-size: 18px">Avaliação:</b>
              <a style="color: #4a4949; padding-left: 5px; font-size: 18px">R$ {{ toCurrency(lote.lote_avaliacao) }}</a>

              <b
                v-if="leilao.leilao_num_pracas > 1"
                style="color: #4a4949; padding-left: 30px; font-size: 18px"
                :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
              >
                1º Leilão:
              </b>
              <a
                v-if="leilao.leilao_num_pracas > 1"
                style="color: #4a4949; padding-left: 5px; font-size: 18px"
                :class="leilao.leilao_1_realizado === 1 ? 'realizado' : ''"
              >
                R$ {{ toCurrency(lote.lote_valor_1) }}
              </a>

              <b
                v-if="leilao.leilao_num_pracas >= 2"
                style="color: #4a4949; padding-left: 30px; font-size: 18px"
                :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''"
              >
                2º Leilão:
              </b>
              <a
                v-if="leilao.leilao_num_pracas >= 2"
                style="color: #4a4949; padding-left: 5px; font-size: 18px"
                :class="leilao.leilao_2_realizado === 1 ? 'realizado' : ''"
              >
                R$ {{ toCurrency(lote.lote_valor_2) }}
              </a>

              <b
                v-if="leilao.leilao_num_pracas >= 3"
                :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''"
                style="color: #4a4949; padding-left: 30px; font-size: 18px"
              >
                3º Leilão:
              </b>
              <a
                v-if="leilao.leilao_num_pracas >= 3"
                :class="leilao.leilao_3_realizado === 1 ? 'realizado' : ''"
                style="color: #4a4949; padding-left: 5px; font-size: 18px"
              >
                R$ {{ toCurrency(lote.lote_valor_3) }}
              </a>

              <b
                v-if="leilao.leilao_num_pracas >= 4"
                :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''"
                style="color: #4a4949; padding-left: 30px; font-size: 18px"
              >
                4º Leilão:
              </b>
              <a
                v-if="leilao.leilao_num_pracas >= 4"
                :class="leilao.leilao_4_realizado === 1 ? 'realizado' : ''"
                style="color: #4a4949; padding-left: 5px; font-size: 18px"
              >
                R$ {{ toCurrency(lote.lote_valor_4) }}
              </a>

              <div></div>

              <b v-if="leilao.leilao_num_pracas == 1" style="color: #4a4949; padding-left: 30px; font-size: 18px">Único leilão:</b>
              <a v-if="leilao.leilao_num_pracas == 1" style="color: #4a4949; padding-left: 5px; font-size: 18px">
                R$ {{ toCurrency(lote.lote_valor_1) }}
              </a>
            </div>
            -->
          </section>
        </div>
      </div>
    </a>
  </div>

  <div class="card-footer clearfix">
    <!-- TOTAIS  -->
    <div style="font-size: 13px" class="float-left" aria-live="polite">
      Exibindo lotes do {{ inicio + 1 }} ao {{ inicio + lotes.length }}
      <p>Total de lotes {{ total }}</p>
    </div>

    <!-- PAGINAÇÃO  -->
    <ul class="pagination pagination-sm m-0 float-right">
      <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

      <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
        <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
          {{ pagina }}
        </a>
      </li>

      <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
    </ul>
  </div>

  <modal-contato v-if="exibir_modal_contato" :user="user" :pre_assunto="getPre(pre_assunto)" />
</template>

<script>
import auxFormatacao from "../../controller/auxFormatacao";
import wppController from "../../controller/wppController";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import currencyController from "../../controller/currencyController";
import moment from "moment";

import useVueLidate from "@vuelidate/core";
import { computed, reactive } from "vue";
import { helpers } from "@vuelidate/validators";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [wppController, sweetAlert, Swal, currencyController, auxFormatacao],

  props: ["leilao", "user", "habilitacao"],

  components: { Loading },

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      situacao_lote: "",
      categoria: "",
      tipo_lote: "",
      forma_pagamento: "",
      lotes: "",
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 60,
      filtro: "",
      venda_direta: false,
      pre_assunto: "",
      searchBuscado: false,
      show_habilitacao: false,
      show_aguardando_habilitacao: false,
      show_habilitacao_bloqueada: false,
      show_auditorio_btn: false,
      pagina_atual: 1,
      exibir_modal_contato: false,
      exibir_modal_habilitacao: false,
      btn_habilitacao_style: "",
      pracas_fechadas: false,
    };
  },

  setup() {
    const formData = reactive({
      termos: false,
    });

    const rules = computed(() => {
      return {
        termos: { aceitarTermos: helpers.withMessage(" Você precisa aceitar os termos de uso", aceitarTermos) },
      };
    });

    const aceitarTermos = (value) => {
      return value;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log("Todos os lotes");
    console.log(this.leilao);
    console.log(this.user);
    console.log(this.leilao.lotes);

    //VALIDAÇÕES BOTÕES
    if (
      this.leilao.leilao_1_modalidade == "venda" ||
      this.leilao.leilao_2_modalidade == "venda" ||
      this.leilao.leilao_3_modalidade == "venda" ||
      this.leilao.leilao_4_modalidade == "venda" ||
      this.leilao.leilao_retirado == 1 ||
      this.leilao.leilao_oculto == 1 ||
      this.leilao.leilao_suspenso == 1 ||
      this.leilao.leilao_pausado == 1 ||
      this.leilao.leilao_encerrado == 1
    ) {
      this.show_habilitacao = false;
    } else if (this.user) {
      if ((this.user && this.user.profile && this.user.profile.magistrado) || this.user.admin) {
        this.show_habilitacao = false;
        this.show_auditorio_btn = true;
      } else if (this.user.status == "liberado") {
        if (!this.habilitacao) {
          this.show_habilitacao = true;
        } else if (this.habilitacao.status == "aguardando") {
          this.show_aguardando_habilitacao = true;
        } else if (this.habilitacao.status == "bloqueado") {
          this.show_habilitacao_bloqueada = true;
        } else if (this.habilitacao.status == "liberado") {
          this.show_auditorio_btn = true;
          this.user_habilitado = true;
        }
      }
    } else {
      this.btn_habilitacao_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
      this.show_habilitacao = true;
      this.show_auditorio_btn = false;
    }

    //FIM
    if (this.leilao.leilao_1_modalidade == "venda") {
      this.venda_direta = true;
    }

    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    if (page) {
      this.inicio = this.qtd_por_pagina * (page - 1);
      this.pagina_atual = Number(page);
    }
    this.buscarLotes();
  },

  methods: {
    voltar() {
      const urlParams = new URLSearchParams(window.location.search);
      let filter = urlParams.get("origin");

      if (filter) {
        if (filter == "agenda") {
          window.open("/agenda", "_self");
        }
      } else {
        history.back();
      }
    },

    getValorAtual(lote) {
      //PRAÇA ATUAL
      if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
        return lote.lote_valor_1;
      } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
        return lote.lote_valor_2;
      } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
        return lote.lote_valor_3;
      } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
        return lote.lote_valor_4;
      } else {
        this.pracas_fechadas = true;
        return null;
      }
    },

    getComitente() {
      let comitente = this.leilao.comitente.nome;

      if (this.leilao.comitente.cidade) {
        if (this.leilao.comitente.cidade.nome) {
          comitente = comitente + " - " + this.leilao.comitente.cidade.nome;
        }

        if (this.leilao.comitente.estado.sigla) {
          comitente = comitente + " - " + this.leilao.comitente.estado.sigla;
        }
      }

      return comitente;

      //ALTERADO EM 05/06/2026
      /*
      let comitente = lote.processo.processo_vara;

      if (lote.processo.cidade) {
        if (lote.processo.cidade.nome) {
          comitente = comitente + " - " + lote.processo.cidade.nome;
        }

        if (lote.processo.estado.sigla) {
          comitente = comitente + " - " + lote.processo.estado.sigla;
        }
      }
      */
      //FIM

      /*
      if (comitente && comitente.length > 80) {
        return comitente.substring(0, 80) + "...";
      } else {
        return comitente;
      }
        */

      return comitente;
    },

    aguardandoLiberacao() {
      this.showErrorMessageWithButtonAndReload("Ops...", "Aguarde liberação. Clique em OK para atualizar o status da tela.");
    },

    checkHabilitacao() {
      this.exibir_modal_contato = false;
      this.exibir_modal_habilitacao = false;
      this.show_contato = false;

      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/user/habilitacao/check`, data)
        .then((response) => {
          console.log(response.data);

          this.isLoading = false;

          if (response.data.success) {
            if (response.data.lote_categoria) {
              this.checkRestricaoCategorias(response.data.lote_categoria);
            } else {
              this.exibir_modal_habilitacao = true;

              this.$nextTick(function () {
                document.getElementById("cancelar").click();
              });
            }
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/leilao/" + this.leilao.id + "/lotes");
          }
        })
        .catch((error) => {
          this.isLoading = false;

          console.log(error);

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndRedirectIfConfirm(
                "Ops...",
                "Para essa ação você precisa estar logado. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
            } else {
              this.showErrorMessageWithButtonAndRedirect(
                "Ops..",
                "Para essa ação você precisa estar logado. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
              //this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
          }
        });
    },

    checkRestricaoCategorias(lote_categoria) {
      let html = "";

      console;

      if (lote_categoria.nome == "Sucatas") {
        html = "Para pedir habilitação em lotes de sucata você precisa ter autorização do Detran. Deseja continuar?";
      }
      if (lote_categoria.nome == "Vagas de Garagem") {
        html = "Para pedir habilitação em lotes de vagas de garagem você precisa ser morador do endereço. Deseja continuar?";
      }

      this.$swal
        .fire({
          title: "Atenção",
          html: html,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            this.exibir_modal_habilitacao = true;

            this.$nextTick(function () {
              document.getElementById("cancelar").click();
            });
          }
        });
    },

    checkIsHabilitado() {
      this.show_contato = false;

      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/user/auditorio/check`, data)
        .then((response) => {
          console.log(response.data);

          this.isLoading = false;

          if (response.data.habilitado) {
            if (this.user && this.user.role == "admin") {
              window.location.href = "/admin/auditorio_user/" + this.leilao.id;
            } else {
              window.location.href = "/user/auditorio/" + this.leilao.id;
            }
          } else if (response.data.msg) {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", "Favor atualizar a tela.", "/user/habilitacoes");
          }
        })
        .catch((error) => {
          this.isLoading = false;

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndRedirect(
                "Ops...",
                "Para entrar no auditório você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
            } else {
              this.showErrorMessageWithButtonAndRedirect(
                "Ops..",
                "Para entrar no auditório você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
              //this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
          }
        });
    },

    getDataText() {},

    getPre() {
      return "Leilão " + this.leilao.id;
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    getUrlLote(lote) {
      return "/lote/" + lote.id;
    },

    limparFiltros() {
      this.filtro = "";
      this.buscarLotes();
    },

    buscarLotes() {
      let data = {
        leilao_id: this.leilao.id,
        search: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/lotes/search`, data)
        .then((response) => {
          console.log(response.data);

          if (this.filtro && this.filtro != "") {
            this.searchBuscado = true;
          } else {
            this.searchBuscado = false;
          }

          this.lotes = response.data.lotes;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    selecionarPagina(pagina) {
      /*
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        //if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      }
        */

      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        this.buscarLotes();

        window.history.replaceState(null, null, "?page=" + pagina);
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        this.buscarLotes();

        window.history.replaceState(null, null, "?page=" + this.max_page);
      }
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    getImagePath(lote) {
      if (lote.thumb) {
        if (lote.thumb.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + lote.thumb.path + "/" + lote.thumb.thumb;
        } else if (lote.thumb.path.includes("rochaleiloes") || lote.thumb.img.includes("fotos_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + lote.thumb.path + "/" + lote.thumb.thumb;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + lote.thumb.path + "/" + lote.thumb.thumb;
        }
      } else {
        return "/images/logo.png";
      }
    },

    getImagePathLeilao(leilao) {
      if (leilao.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + leilao.path + "/" + leilao.arquivo;
      } else if (leilao.path.includes("rochaleiloes") || leilao.arquivo.includes("fotos_")) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + leilao.path + "/" + leilao.arquivo;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + leilao.path + "/" + leilao.arquivo;
      }
    },

    validarLeilaoData() {
      let data = {
        leilao_id: this.leilao.id,
      };

      axios.post(`/user/leilao/serach_by_id`, data).then((response) => {
        let praca_atual = 0;
        let leilao = response.data.leilao;
        let proxima_data = "";

        //PRAÇA ATUAL
        if (leilao.leilao_num_pracas >= 1 && leilao.leilao_1_realizado == 0) {
          praca_atual = 1;
          proxima_data = leilao.leilao_1_data;
        } else if (leilao.leilao_num_pracas >= 2 && leilao.leilao_2_realizado == 0) {
          praca_atual = 2;
          proxima_data = leilao.leilao_2_data;
        } else if (leilao.leilao_num_pracas >= 3 && leilao.leilao_3_realizado == 0) {
          praca_atual = 3;
          proxima_data = leilao.leilao_3_data;
        } else if (leilao.leilao_num_pracas >= 4 && leilao.leilao_4_realizado == 0) {
          praca_atual = 4;
          proxima_data = leilao.leilao_4_data;
        }

        //VERIFICANDO SE TEM DATA PRA ENCERRAR HABILITAÇÕES
        if (this.leilao.leilao_tempo_limite_habilitacao >= 0) {
          console.log("Entrou na validação data");

          var data_agora = moment(new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }), "MM-DD-YYYY HH:mm:ss A");
          var data_proxima_praca = moment(proxima_data);

          console.log("Data agora 1");
          console.log(proxima_data);
          console.log(data_agora.format("DD/MM/yyyy HH:mm:ss"));
          console.log(data_proxima_praca.format("DD/MM/yyyy HH:mm:ss"));

          if (data_proxima_praca.format("DD/MM/yyyy HH:mm:ss") != "Invalid date") {
            let minutos = this.leilao.leilao_tempo_limite_habilitacao ? this.leilao.leilao_tempo_limite_habilitacao : 0;

            data_proxima_praca = data_proxima_praca.subtract(minutos, "minutes");

            console.log("Data agora 2");
            console.log(data_agora.format("DD/MM/yyyy HH:mm:ss"));
            console.log(data_proxima_praca.format("DD/MM/yyyy HH:mm:ss"));

            if (data_agora.isAfter(data_proxima_praca)) {
              /*
              let msg =
                "Não é possível pedir habilitação. As habilitações encerraram em " +
                data_proxima_praca.format("DD/MM/yyyy") +
                " às " +
                data_proxima_praca.format("HH:mm:ss");
                */

              let msg = "Não é possível pedir habilitação. As habilitações estão encerradas.";
              
              this.showErrorMessageWithButton("Ops...", msg);
            } else {
              this.pedirHabilitacao();
            }
          } else {
            this.showErrorMessageWithButton("Ops...", "Não foi possível solicitar habilitação.");
          }
        } else if (this.leilao.leilao_tempo_limite_habilitacao == -1) {
          /*
          let msg =
            "Não é possível pedir habilitação. As habilitações encerraram em " +
            moment(proxima_data).format("DD/MM/yyyy") +
            " às " +
            moment(proxima_data).format("HH:mm:ss");
            */

          let msg = "Não é possível pedir habilitação. As habilitações estão encerradas.";

          this.showErrorMessageWithButton("Ops...", msg);
        } else {
          console.log("Pulou validação data");
          this.pedirHabilitacao();
        }
      });
    },

    pedirHabilitacao() {
      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/user/habilitacao/pedir`, data)
        .then((response) => {
          console.log("Retorno habilitação");
          console.log(response.data);

          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Habilitação solicitada!", "/leilao/" + this.leilao.id + "/lotes");
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/leilao/" + this.leilao.id + "/lotes");
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.validarLeilaoData();
      } else {
        console.log(this.v$);
      }
    },

    create() {
      this.isLoading = true;

      let data = {
        nome: this.nome,
        email: this.email,
        senha: this.senha,
        chave: this.generateKey(),
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/users/create`, data)
        .then((response) => {
          console.log("Usuário criado!");
          console.log(response);

          this.showSuccessMessage("Usuário criado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}

.im:hover {
  transform: scale(0.9);
  transition-duration: 500ms;
}

.realizado {
  text-decoration: line-through;
}

.current-page {
  background-color: #301904 !important;
  color: white !important;
}

.modal-content {
  width: 1100px;
  margin-left: -250px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -20px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
